export const location = {
  defaultLAT: 32.109333,
  defaultLNG: 34.855499,
};
